import GroupTreeColumn from './GroupTreeColumn';

export default GroupTreeColumn;
